import FormExample from '../components/FormExample';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { usePageMeta } from '../hooks/usePageMeta';
import { useWebsiteData } from '../hooks/useWebsiteData';
// import { ParallaxImages } from '../components/ParallaxImages';
import { ImageExpand } from '../components/ImageExpand';
import { HeroImage } from '../components/HeroImage';
import Footer from '../components/Footer';
import ImageCollage, { ImageItem } from '../components/ImageAllDetails';

export const Route = createFileRoute('/')({
  component: HomeComponent,
});

function HomeComponent() {
  usePageMeta(
    'Boyden Renovations | Custom Home Renovations & Remodeling',
    'Boyden Renovations transforms spaces with expert craftsmanship. From kitchen remodels to full home renovations, we bring your vision to life.'
  );

  const navigate = useNavigate();

  const { data } = useWebsiteData();

  const imagesArray: ImageItem[] = [
    {
      src: 'https://res.cloudinary.com/dtgkdtn4o/image/upload/v1777498905/Website/Beinlich/LGphoto-23.webp',
      alt: 'Interior renovation',
    },
    {
      src: 'https://res.cloudinary.com/dtgkdtn4o/image/upload/v1777663207/Website/Wolf/magreephoto-1397.webp',
      alt: 'Interior renovation',
    },
    {
      src: 'https://res.cloudinary.com/dtgkdtn4o/image/upload/v1777655709/Website/Gregory_Hall_Bathroom/LGphoto-2.webp',
      alt: 'Interior renovation',
    },
    {
      src: 'https://res.cloudinary.com/dtgkdtn4o/image/upload/v1777656959/Website/McGee/LGphoto-3.webp',
      alt: 'Interior renovation',
    },
    {
      src: 'https://res.cloudinary.com/dtgkdtn4o/image/upload/v1777662182/Website/Stover/lilygrace-3643.webp',
      alt: 'Interior renovation',
    },
    {
      src: 'https://res.cloudinary.com/dtgkdtn4o/image/upload/v1777654027/Website/Carr_Hall_Bathroom/LGphoto-16.webp',
      alt: 'Interior renovation',
    },
    {
      src: 'https://res.cloudinary.com/dtgkdtn4o/image/upload/v1777656278/Website/Grunder/magree-955.webp',
      alt: 'Interior renovation',
    },
  ];

  return (
    <>
      <HeroImage
        imageUrl="https://res.cloudinary.com/dtgkdtn4o/image/upload/v1777654535/Website/Carr_Kitchen/LGphoto-1.webp"
        title={`Transformed Spaces,\n Elevated Living`}
        overlayOpacity={0.2}
        cta={() => {
          navigate({
            to: '/portfolio',
          });
        }}
        navTheme="dark"
      />
      <div className="w-full h-auto flex flex-col" data-nav-theme="light">
        <ImageExpand imageArray={imagesArray} isLoaded={!!data} />
        <ImageCollage />
        <FormExample isLoaded={!!data} />
        <Footer isLoaded={!!data} />
      </div>
    </>
  );
}
